import React, { useState } from 'react';
import ReactPlayer from 'react-player';
import Card from '../../elements/card';
import CustomTabGroup from '../../elements/tab/custom-tab-group';
import TabGroup from '../../elements/tab/tab-group';
import ComingSoon from '../../widgets/coming-soon';

const StakecutUniversitySection = () => {
  const [activeTab, setActiveTab] = useState('affiliate trainings(free)');

  const videos = [
    {
      id: 1,
      url: 'https://www.youtube.com/embed/EvEHD_RmSqE',
      title: 'How to Set Up Your Lead Funnel ',
      videoRef: '701838770',
    },
    {
      id: 2,
      url: 'https://player.vimeo.com/video/701838770',
      title: 'How to Create The Perfect Lead Magnets ',
      videoRef: '701838770',
    },
    {
      id: 3,
      url: 'https://www.youtube.com/embed/-Ls98i3WFjs',
      title: 'How to Write Affiliate Promo Swipes ',
      videoRef: '701838770',
    },
    {
      id: 4,
      url: 'https://player.vimeo.com/video/707453064',
      title: 'How to Write Full Promo Copy ',
      videoRef: '707453064',
    },
    {
      id: 5,
      url: 'https://youtu.be/DskZlz19zPY',
      title:
        'Complete facebook Ads Training || Stakecut $1000 30days Challenge',
    },
  ];

  const Affiliate = () => {
    return (
      <section className="mb-6 grid lg:grid-cols-2 grid-cols-1 gap-4">
        {videos.map(video => (
          <div key={video.id}>
            <Card>
              <div className="col-span-1">
                <div>
                  <h3 className="text-base font-medium text-gray-600 mb-4">
                    {video.title}
                  </h3>
                </div>
                <div className="relative pt-[56.25%]">
                  <ReactPlayer
                    url={video.url}
                    className="absolute top-0 left-0"
                    height="100%"
                    width="100%"
                    config={{
                      vimeo: {
                        playerOptions: {
                          id: video.videoRef,
                        },
                      },
                    }}
                    controls={true}
                  />
                </div>
              </div>
            </Card>
          </div>
        ))}
      </section>
    );
  };

  const renderList = tab => {
    switch (tab) {
      case 'affiliate trainings(free)':
        return <Affiliate />;
      default:
        return <ComingSoon />;
    }
  };

  return (
    <section>
      <div className="lg:hidden">
        <CustomTabGroup
          active={activeTab}
          setActive={setActiveTab}
          data={[
            { id: 1, name: 'Affiliate Trainings(FREE)' },
            { id: 2, name: 'Copywriting' },
            { id: 3, name: 'Sales Funnel' },
            { id: 4, name: 'Media Buying' },
            { id: 5, name: 'Content Creation ' },
            { id: 6, name: 'Graphics Design' },
          ]}
        />
      </div>
      <div className="hidden lg:block">
        <TabGroup
          active={activeTab}
          setActive={setActiveTab}
          data={[
            { id: 1, name: 'Affiliate Trainings(FREE)' },
            { id: 2, name: 'Copywriting' },
            { id: 3, name: 'Sales Funnel' },
            { id: 4, name: 'Media Buying' },
            { id: 5, name: 'Content Creation & Writing ' },
            { id: 5, name: 'Graphics Design' },
          ]}
        />
      </div>

      <section className="mt-10">{renderList(activeTab)}</section>
    </section>
  );
};

export default StakecutUniversitySection;
